// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.7.12';
export const APP_NAME = 'casa-doc';
export const FILE_HASH = '1785746899880';
export const BUILD_DATE = '2026-08-03T08:48:19.880Z';
/* tslint:enable */
